import { createFileRoute } from '@tanstack/react-router';
import OrganizationPage from '@/pages/setup/OrganizationPage';
import { requireSetupPageAccess } from '@/lib/setup-route-guard';

export const Route = createFileRoute('/_authenticated/setup/organization')({
  beforeLoad: () => requireSetupPageAccess('/setup/organization'),
  component: OrganizationPage,
});
